import React from "react";
import { Paragraph } from "@project-stories/elements/Paragraph/Paragraph";
import Headings from "@project-stories/elements/Headings/Headings";
import useColoredTextParser from "@project-stories/../hooks/useColoredTextParser"; 

const ContentArea = ({ settings, description, isMobile }) => {
    let heading = settings.title;
    const content_gap = isMobile ? settings.content_gap_mobile : settings.content_gap_desktop;
    const heading_width = isMobile ? settings.heading_max_width_mobile : settings.heading_max_width;
    const content_width = isMobile ? settings.content_max_width_mobile : settings.content_max_width; 

    // Use the colored text parser hook for the heading
    const renderFormattedTitle = useColoredTextParser({
        title: heading,
        accentTitleParts: settings.accent_title_parts,
        accentColor: settings.accent_color,
        headerStyle: isMobile ? settings.heading_type_mobile : settings.heading_type,
        seoStyle: settings?.seo_title_font_type,
        HeadingsComponent: Headings,
    });

    return (
        <div className={`gap-[${content_gap}px] flex flex-col`}>
            {settings.tagline && (
                <Paragraph text={settings.tagline} type={"bc"} />
            )}
            <div className={heading_width !== 0 ? `max-w-[${heading_width}px]` : ''}>{heading && renderFormattedTitle()} </div>
            <div className={`flex flex-col ${content_width !== 0 ? `max-w-[${content_width}px]` : ''}`} >
                {settings.subheading && (
                    <Paragraph
                        text={settings.subheading}
                        type={`${isMobile ? settings.subheading_style_mobile : settings.subheading_style}`}
                    />
                )}
                {description && (
                    <Paragraph
                        text={description}
                        maxChars={settings.content_max_chars}
                        shouldTruncateText={true}
                        type={`${isMobile ? settings.content_style_mobile : settings.content_style}`}
                    />
                )}
            </div>
        </div>
    );
};

export default ContentArea;
